/**
 * InputTextarea Label Wrapper Classes
 */

const inputLabelWrapperClasses = '';

/**
 * Blog Theme
 */

const inputTextareaBlogTheme = {
  inputLabelWrapperThemeClasses: inputLabelWrapperClasses,
};

export default inputTextareaBlogTheme;
